<template>
  <div class="homeIndexWarp">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item,index) in swiper":key="index">
        <img :src="item.imageUrl" alt="">
      </el-carousel-item>
    </el-carousel>
    <div class="txt inner">
      <p class="title">完善的电子合同解决方案</p>
      <p class="subTitle">
        支持多业务场景、符合法律效力的签署服务
      </p>
    </div>
    <div class="itemList">
      <div class="inner">
        <div class="item">
          <div class="box k1"></div>
          <p class="title">SaaS服务</p>
          <p class="des">
            基于云平台轻量化的电子合同签署服务
          </p>
        </div>
        <div class="item">
          <div class="box k2"></div>
          <p class="title">本地化部署</p>
          <p class="des">
            支持用户本地部署，与OA、ERP、CRM无缝对接
          </p>
        </div>
        <div class="item">
          <div class="box k3"></div>
          <p class="title">证据保全</p>
          <p class="des">
            实现合同固化和保全，增加电子合同签署法律效力
          </p>
        </div>
      </div>
    </div>
    <div class="aboutOurs">
      <div class="de">
        <div class="aboutTxt">
          <p class="title">关于我们</p>
          <p class="des">
            AB签(ABSIGN)是中科凌云旗下的子品牌，为互联网行业的需求应运而生，励志为用户提供可信任的无纸化交付服务。AB签(ABSIGN)责任于最大限度的减少纸张的使用量,
            以为节约社会资源、保护生态环境为己任，向用户提供以密码技术为基础、具有法律效力的无纸化交解决方案。无纸化志在你我，为信而签，助您AB签。</p>
          <p class="more" @click="goSomePage('about')">查看更多</p>
        </div>
      </div>
    </div>
    <div class="txt inner">
      <p class="title">典型场景</p>
      <p class="subTitle">
        电子合同签署服务可满足于基于互联网各种签字盖章需求
      </p>
    </div>
    <div class="itemList four">
      <div class="inner">
        <div class="item">
          <div class="box k4"></div>
          <p class="title">供应链</p>
        </div>
        <div class="item">
          <div class="box k5"></div>
          <p class="title">招标采购</p>
        </div>
        <div class="item">
          <div class="box k6"></div>
          <p class="title">人资劳务</p>
        </div>
        <div class="item">
          <div class="box k7"></div>
          <p class="title">报告文书</p>
        </div>
      </div>
    </div>
    <div class="company">
      <div class="de">
        <div class="logo"></div>
        <p class="companyName t">北京中科凌云科技有限公司</p>
        <p class="companyTel t">联系电话: 010-52741048</p>
        <p class="companyBtns">
          <span class="btn">隐私政策</span>
          <i class="sx"></i>
          <span class="btn">服务协议</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapActions, mapGetters} from 'vuex';
  import axios from 'axios';
  //  GET
  export default {
    data(){
      return{
        swiper:[]
      }
    },
    computed: {
      ...mapGetters([
        "gUserInfo"
      ])
    },
    created(){
      let _this = this;
      axios({
        method:'get',
        url: window.wtEnv.baseApiUrl + '/api/account/findImageList',
        data:{}
      }).then(function(re){
        _this.swiper = re.data.data
      }).catch(function (error) {
        console.log(error)
      });
    },
    methods:{
      goSomePage(item){
        this.$router.push(`/${item}`)
      }
    }
  }
</script>
<style>
  @import "../../../assets/less/homeIndex.css";
</style>



// WEBPACK FOOTER //
// src/components/home/index/index.vue